import * as tocbot from "tocbot";
import { debounce } from "./kw-validation";
import { tocOverlapTrigger } from "./lib/kw-overlap";

(() => {
  const tocItem = document.querySelector(".kw-toc-top > .gh-sidebar");
  const tocAsideItem = document.querySelector(".gh-sidebar.kw-toc-aside");
  const tocAsideContent = tocAsideItem?.querySelector(".kw-toc--content");
  if (!tocItem || !tocAsideItem) {
    return;
  }

  const btn = tocAsideItem.querySelector("button.kw-toc--button");
  const wrap = tocAsideItem.querySelector(".kw-toc-wrap");
  const offset = 80 + tocItem?.offsetHeight ? tocItem?.offsetHeight : 0;

  const ghToc = tocItem.querySelector(".gh-toc");
  const ghAsideToc = tocAsideItem.querySelector(".gh-toc");

  const tocbotOptions = {
    contentSelector: ".kw-article--wrapper",
    headingSelector: "h2",
    hasInnerContainers: true,
    scrollSmooth: true,
    throttleTimeout: 100,
  };

  tocbot.init({
    ...tocbotOptions,
    tocElement: ghToc,
    throttleTimeout: 400,
  });

  setTimeout(() => {
    tocbot.init({
      ...tocbotOptions,
      tocElement: ghAsideToc,
    });
  }, 400);

  if (btn) {
    btn.onclick = () => {
      window.requestAnimationFrame(() => {
        tocAsideItem.classList.toggle("open");
        tocAsideContent?.classList.toggle("open");

        if (!wrap) return;
        if (tocAsideItem.classList.contains("open")) {
          const maxHeightLimit = window.innerHeight - 230;
          const newHeight = wrap.scrollHeight - 15;
          wrap.style.maxHeight =
            (newHeight > maxHeightLimit ? maxHeightLimit : newHeight) + "px";
        } else {
          wrap.style.maxHeight = null;
        }
      });
    };
  }

  function tocOverScreenTrigger() {
    const tocRect = tocItem.getBoundingClientRect();
    window.requestAnimationFrame(() => {
      if (window.screen.width < 990) return;
      if (tocRect.bottom > offset) {
        if (!tocAsideItem.classList.contains("kw-hide")) {
          tocAsideItem.classList.add("kw-hide");
          tocAsideItem.classList.remove("open");
          tocAsideContent?.classList.remove("open");
          wrap.style.maxHeight = null;
        }
      } else {
        if (tocAsideItem.classList.contains("kw-hide")) {
          tocAsideItem.classList.remove("kw-hide");
        }
      }
    });
  }

  const debouncedTocOverScreenTrigger = debounce(tocOverScreenTrigger, 35);
  window.addEventListener("scroll", debouncedTocOverScreenTrigger);
})();
